// src/features/explore/ExploreSearch.tsx — sticky controlled search field with leading icon.
import styled from 'styled-components';
import type { ChangeEvent } from 'react';
import { Icon } from '@/icons';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  min-width: 0;
  min-height: 44px;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.glassBg};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  color: ${({ theme }) => theme.color.textMuted};
  &:focus-within {
    border-color: ${({ theme }) => theme.color.accentCyan};
  }
`;

const Input = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
  &::placeholder {
    color: ${({ theme }) => theme.color.textMuted};
  }
`;

export interface ExploreSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function ExploreSearch({ value, onChange }: ExploreSearchProps) {
  return (
    <Wrap>
      <Icon name="search" size={18} />
      <Input
        type="search"
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder="Search posts, people, communities…"
        aria-label="Search Explore"
      />
    </Wrap>
  );
}
